import { Row, Col, Button, Card } from "../../ui/ot";
import { Form } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";


const TemplateForm = ({
  propsForm = null,
  formReloadCount = 0,
  selectOption = [],
  onFormFinish = () => {},
}) => {
  const [form] = Form.useForm();
  const setFormValuesOtherThings = (formValues) => {
    let newFormValues = {
      ...formValues,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
  };

  const onChangeFileValue = (values) => {
  };
  const setDataInitialization = () => {
    
  };
  const onFinish = (values) => {
    let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss");
    let announce_time_end = dayjs(values?.announce_time_end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    console.log(values.information_community_data);
    onFormFinish({
      ...values,
      news_time,
      announce_time_end,
    });
    form.resetFields();
  };
 
  const onValuesChange = () => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    setFormValuesOtherThings(formValues);
  };

  useEffect(() => {
    setDataInitialization();
  }, []);
  useEffect(() => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    onChangeFileValue(formValues);
  }, [formReloadCount]);

  return (
    <Row gutter={[10, 20]} justify="space-around" style={{ padding: "3vmin" }}>
      <Col span={24}>
        <Form
          layout="vertical"
          form={propsForm ? propsForm : form}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[8, 8]}>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Card
                cover={
                  <img
                    alt="example"
                    src="https://gw.alipayobjects.com/zos/rmsportal/JiqGstEfoWAOHiTxclqi.png"
                  />
                }
              >
                <Row gutter={[8, 8]} style={{ justifyContent: "center", padding: "2vmin" }}>
                  <Col>
                    <Button htmlType="button" size="large">
                      選擇
                    </Button>
                  </Col>
                  <Col>
                    <Button type="primary" htmlType="submit" size="large">
                      預覽
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default TemplateForm;
